module.exports = __webpack_public_path__ + "static/ub-da975717f99c288e1e0fc3e456a01f63.png";